// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"827db3c1","182":"3dc484bb","252":"ac556b70","537":"709c375f"}[chunkId] + ".chunk.js";
};